import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightSearchTerm'
})
export class HighlightSearchTermPipe implements PipeTransform {

  transform(value: string, args: string): any {
    if (!value || !args) return value;
    if (value.includes('highlightSearchTerm')) { return value; }
    const pattern = this.cleanForRegex(args);
    if (!pattern) return value;
    try {
      const re = new RegExp(pattern, 'gi');
      return value.replace(re, match => `<span class="highlightSearchTerm">${match}</span>`)
    }
    catch {
      return value;
    }
  }
  private cleanForRegex(rawterm: string): string {
    if (!rawterm) return '';
    let term = rawterm.trim();
    const isQuoted = term.startsWith('"') && term.endsWith('"');
    if (isQuoted) {
      term = term.slice(1, -1);
    }

    const tokens = term.split(/\s+/).filter(Boolean);
    const buildToken = (tok: string): string => {
      if (!tok) return '';
      const startwildcart = term.startsWith('*');
      const endwildcart = term.endsWith('*');
      tok = tok.replace(/^\*+|\*+$/g, '');
      tok = tok.replace(/\*/g, '[\\w-]*').replace(/\?/g, '[\\w-]');
      tok = tok.replace(/[-\\^$+?.()|[\]{}]/g, '\\$&');
      if (isQuoted) {
        if (!startwildcart) tok = '\\b' + tok;
        if (!endwildcart) tok = tok + '\\b';
      }
      return tok;
    }

    const tokenPatterns = tokens.map(buildToken).filter(Boolean);
    if (isQuoted) {
      return tokenPatterns.join('\\s+');
    }
    if (tokenPatterns.length === 1) {
      return tokenPatterns[0];
    }
    return tokenPatterns.join('|') + '|' + tokenPatterns.join('\\s+');

  }


}
